import { getLocation } from '@opengov/compose-app-router/selectors';
import { Map } from 'immutable';
import { createSelector } from '@opengov/compose-app/reselect';
import { featureFlagEffects } from '@opengov/feature-flag/effects';

import { getEntity } from '../entity/selectors';
import { composeEffects } from '../module';
import { getSession } from '../session/selectors';

export const coreFeatureFlagEffects = composeEffects('core-feature-flags', (compose) => ({
  getFlags: compose.statefulEffect(
    createSelector(getEntity, getLocation, getSession, (currentEntity, location, session) => ({
      session,
      entitySubdomain: location?.params?.entitySubdomain,
      currentEntityId: currentEntity.id
    })),
    async (params, payload?: { entityFriendlyId?: string } | undefined) => {
      const currentEntityId =
        payload?.entityFriendlyId ||
        params.entitySubdomain ||
        window.location.pathname.split('/')[2] ||
        params.currentEntityId;

      return featureFlagEffects.allFlags({ currentEntityId, session: params.session }).catch(Map);
    }
  )
}));
